import { PRICE_POINTS } from '../../data/conjointData';
import { formatPrice, formatPercent, formatNumber } from '../../lib/formatters';
import { InfoButton } from '../common/Tooltip';

interface Props { selectedPrice: number; }

export function ElasticityTable({ selectedPrice }: Props) {
  let cumRevenue = 0;

  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-4">
        <h3 className="text-heading font-semibold text-secondary uppercase tracking-wider">Elasticity Data Table</h3>
        <InfoButton helpKey="elasticityTable" size={13} />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-secondary">
              <th className="text-left py-2 px-2 font-medium">Price</th>
              <th className="text-right py-2 px-2 font-medium">Times Shown</th>
              <th className="text-right py-2 px-2 font-medium">Times Selected</th>
              <th className="text-right py-2 px-2 font-medium"><span className="inline-flex items-center gap-1">Rate <InfoButton helpKey="adjChoiceRate" size={10} /></span></th>
              <th className="text-right py-2 px-2 font-medium"><span className="inline-flex items-center gap-1">Rev/Prospect <InfoButton helpKey="revenuePerShowing" size={10} /></span></th>
              <th className="text-right py-2 px-2 font-medium">Cum Rev</th>
              <th className="text-right py-2 px-2 font-medium"><span className="inline-flex items-center gap-1">Elasticity <InfoButton helpKey="elasticity" size={10} /></span></th>
            </tr>
          </thead>
          <tbody>
            {PRICE_POINTS.map(pt => {
              cumRevenue += (pt.revenuePerShowing ?? 0) * pt.conceptsShown;
              const isSelected = pt.price === selectedPrice;
              return (
                <tr key={pt.price} className={`border-b border-border/50 transition-colors ${isSelected ? 'bg-chart-teal/10' : ''}`}
                  style={!isSelected ? {} : undefined}
                  onMouseEnter={e => { if (!isSelected) e.currentTarget.style.backgroundColor = 'var(--color-hover-bg)'; }}
                  onMouseLeave={e => { if (!isSelected) e.currentTarget.style.backgroundColor = ''; }}
                >
                  <td className={`py-2 px-2 font-mono ${isSelected ? 'text-chart-teal font-semibold' : 'text-primary'}`}>{formatPrice(pt.price)}</td>
                  <td className="text-right py-2 px-2 font-mono text-secondary">{formatNumber(pt.conceptsShown)}</td>
                  <td className="text-right py-2 px-2 font-mono text-secondary">{formatNumber(pt.conceptsChosen)}</td>
                  <td className="text-right py-2 px-2 font-mono text-primary">{formatPercent(pt.choiceRate)}</td>
                  <td className="text-right py-2 px-2 font-mono text-primary">${(pt.revenuePerShowing ?? 0).toFixed(0)}</td>
                  <td className="text-right py-2 px-2 font-mono text-muted">${formatNumber(Math.round(cumRevenue))}</td>
                  <td className="text-right py-2 px-2 font-mono text-muted">{pt.elasticity == null ? '—' : pt.elasticity.toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
